import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import difference from 'lodash/difference';
import { useSelector } from 'react-redux';
import * as PatientSelectors from 'modules/Patient/selectors';
import * as PatientActions from 'modules/Patient/actions';
import { useAction } from 'hooks';
import CloudDrive from 'modules/CloudDrive';
import PaginatedRenderer from 'components/PaginatedRenderer';
import { AppContext, ProfileContext } from 'context';
import Account from 'modules/Account';
import VisitsHistory from '../../partials/VisitsHistory';
import styles from './VisitHistoryPage.pcss';
import VisitCard from './VisitCard';
const VisitCardList = ({ phiSetVisits, isInProgress, isPerPageOff, page, perPage, onPageChange, onShowNotes })=>/*#__PURE__*/ _jsx(PaginatedRenderer, {
        idKey: "phisetVisitId",
        entities: phiSetVisits,
        page: page,
        perPage: perPage,
        isInProgress: isInProgress,
        onPageChange: onPageChange,
        isPerPageOff: isPerPageOff,
        paginationClassName: styles.pagination,
        children: ({ entities })=>/*#__PURE__*/ _jsx("div", {
                className: styles.contentBox,
                children: entities.map((entity)=>/*#__PURE__*/ _jsx(VisitCard, {
                        phiSetVisit: entity,
                        onShowNotes: onShowNotes
                    }, entity.phisetVisitId))
            })
    });
const VisitHistoryPage = ()=>{
    useStyles(styles);
    const onFetchNotesAction = useAction(CloudDrive.actions.fetchNotes);
    const profileContext = useContext(ProfileContext);
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const notesBatchesIndex = useSelector(PatientSelectors.notesBatchesIndex);
    const { redirect, getUrl } = useContext(AppContext);
    const onFetchNotes = (visit)=>{
        const associatedNotesBatches = get(visit, 'associatedDataIndexKeys.notes', []);
        const diff = difference(associatedNotesBatches, notesBatchesIndex);
        if (!diff.length) {
            return;
        }
        const { phiSetReferenceKey, accessToken, storageProvider, phiSetDocumentId } = patientProfile;
        onFetchNotesAction({
            phiSet,
            phiSetReferenceKey,
            phiSetDocumentId,
            notesBatchesIndex,
            accessToken,
            storageProvider,
            batches: associatedNotesBatches,
            successAction: PatientActions.setNotes
        });
    };
    const onShowNotes = (visit)=>{
        const { phisetVisitId } = visit;
        onFetchNotes(visit);
        redirect(getUrl('mobile-visit-notes', {
            phisetVisitId
        }));
    };
    return /*#__PURE__*/ _jsx(VisitsHistory, {
        mode: "PWD",
        onShowNotes: onShowNotes,
        children: ({ phiSetVisits, page, perPage, isInProgress, onPageChange, onShowNotes: onShowNote })=>/*#__PURE__*/ _jsx(VisitCardList, {
                phiSetVisits: phiSetVisits,
                page: page,
                perPage: perPage,
                isInProgress: isInProgress,
                isPerPageOff: true,
                onPageChange: onPageChange,
                onShowNotes: onShowNote
            })
    });
};
export default VisitHistoryPage;
